/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */
import { ActionCreators } from "actions";
import { capitalize, snakeToCamelCase } from "config/Utilities";
import { store } from ".";
import { DEFAULT_STORE, RootState } from "./types";

type EnumOptionsType<Store> = Partial<{
  [Key in keyof Store as Store[Key] extends string | number
    ? Key
    : never]: Array<Store[Key]>;
}>;

const ENUM_OPTIONS: EnumOptionsType<typeof DEFAULT_STORE> = {
  FULL_DATA_QUERY_TYPE: ["session_count", "duration"],
  DISPLAYED_SUMMIT_VIEW: [
    "Summit",
    "Match",
    "Chat",
    "SessionFinish",
    "DeviceSwitch",
  ],
};

export default function cleanStore() {
  const state = store.getState() as any as RootState;
  for (const [key, validValues] of Object.entries(ENUM_OPTIONS)) {
    const snakeCaseKey = snakeToCamelCase(key);
    const value = state[snakeCaseKey];
    if (!validValues.includes(value)) {
      console.warn(
        `Invalid value for '${snakeCaseKey}' (${value}) expected one of ${JSON.stringify(
          validValues
        )}`
      );
      const action = ActionCreators[`set${capitalize(snakeCaseKey)}`];
      const defaultValue = DEFAULT_STORE[key];
      store.dispatch(action(defaultValue));
    }
  }
}
